module.exports = __webpack_public_path__ + "static/media/Commercial-17.59ea5d58.jpg";